import css from '@styled-system/css';
import styled from 'styled-components';
import { Flex } from '../Flex';
export const Stack = styled(Flex)((props) => css({
    gap: props.gap,
}));
Stack.defaultProps = {
    flexDirection: 'column',
};
